import { useMemo } from "react";
import { Label, Select } from "@hireart/component-library";
import PropTypes from "prop-types";
import { HOUR_OPTIONS, MINUTE_OPTIONS, PERIOD_OPTIONS } from "./constants";
import { getInputValuesFromTime, createFieldChangeHandler } from "./utils";

export const TimePicker = ({
  value,
  onChange,
  isDisabled = false,
  label,
  className = "",
}) => {
  // Derive display values directly from the value prop
  const displayValues = useMemo(() => {
    if (value != null) {
      const inputValues = getInputValuesFromTime(value);
      return {
        hour: inputValues.hour.toString(),
        minute: inputValues.minute.toString().padStart(2, "0"),
        period: inputValues.period,
      };
    }
    return {
      hour: "",
      minute: "",
      period: "",
    };
  }, [value]);

  // Create change handlers using the utility function
  const handleHourChange = createFieldChangeHandler(
    displayValues,
    onChange,
    "hour"
  );
  const handleMinuteChange = createFieldChangeHandler(
    displayValues,
    onChange,
    "minute"
  );
  const handlePeriodChange = createFieldChangeHandler(
    displayValues,
    onChange,
    "period"
  );

  return (
    <div className={`flex min-w-0 flex-1 flex-col gap-1 ${className}`}>
      {label && (
        <Label htmlFor="time-picker" className="body-3" isUnstyled>
          {label}
        </Label>
      )}
      <div className="gap-y-8">
        <div className="grid grid-cols-3 gap-2">
          <Select
            value={displayValues.hour}
            onChange={handleHourChange}
            isDisabled={isDisabled}
            options={HOUR_OPTIONS}
            placeholder="HH"
            className="w-full"
            size="md"
            isLabelUnstyled
          />

          <Select
            value={displayValues.minute}
            onChange={handleMinuteChange}
            isDisabled={isDisabled}
            options={MINUTE_OPTIONS}
            placeholder="MM"
            className="w-full"
            size="md"
            isLabelUnstyled
          />

          <Select
            value={displayValues.period}
            onChange={handlePeriodChange}
            isDisabled={isDisabled}
            options={PERIOD_OPTIONS}
            placeholder="AM/PM"
            className="w-full"
            size="md"
            isLabelUnstyled
          />
        </div>
      </div>
    </div>
  );
};
TimePicker.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
  isDisabled: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string,
};
